// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedPaymentProfileEntryStyles } from "@conklin/Overrides/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry";
import IconNotificationInfo from "@conklin/XDL/Icons/IconNotificationInfo";
import { createLinkIconStyles } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

savedPaymentProfileEntryStyles.hintLink = {
    ...createLinkIconStyles(IconNotificationInfo, "small", "left", false, undefined, undefined, {
        css: css`
            opacity: 1;
            margin-left: 4px;
        `,
    }),
};

savedPaymentProfileEntryStyles.tokenExFrame = {
    cssOverrides: {
        formInputWrapper: css`
            [data-id="frame-wrapper"] {
                width: 110px;
            }
        `,
    },
};
